import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { api } from "../../api/api";
import { IBusinessElement, IBusinesses, IBusinessesState } from ".";

export interface IUpgradeBusinessesElementResponse {
    businessType: number;
    element: IBusinessElement;
    balance: number;
    exp: number;
    profit: number;
}

export const upgradeBusinessesElement = createAsyncThunk<IUpgradeBusinessesElementResponse, { businessType: number, elementType: number }>(
    'upgradeBusinessesElement',
    async ({ businessType, elementType }) => await api.businesses.upgradeElement(businessType, elementType)
);

const upgradeBusinessesElementHandler = (builder: ActionReducerMapBuilder<IBusinessesState>) => {
    builder
        .addCase(upgradeBusinessesElement.pending, (state: IBusinessesState) => {
            state.loading = true;
            state.error = "";
        })
        .addCase(upgradeBusinessesElement.fulfilled, (state: IBusinessesState, action: PayloadAction<IUpgradeBusinessesElementResponse>) => {
            state.loading = false;

            if (!state.activeBusiness || !action.payload)
                return;

            const replaceBusinessElement = (business: IBusinesses, elementToReplace: IBusinessElement) => {
                business.elements = business.elements.filter(element => element.type !== elementToReplace.type);
                business.elements.push(elementToReplace);
            }

            replaceBusinessElement(state.activeBusiness, action.payload.element);
            state.activeBusiness.elements.sort((a, b) => a.type - b.type);
            state.activeBusiness.profit = action.payload.profit;

            const business = state.businesses.find(business => business.type === action.payload.businessType);
            if (business) {
                replaceBusinessElement(business, action.payload.element);
                business.profit = action.payload.profit;
            }
        })
        .addCase(upgradeBusinessesElement.rejected, (state: IBusinessesState) => {
            state.loading = false;
            state.error = 'Unable to upgrade business element';
        });
};

export default upgradeBusinessesElementHandler;